module.exports = __webpack_public_path__ + "img/mma-beginners.b7f13a7f.jpg";